import React from 'react';

const CheckLater = (props) => (
  		<div className="fineryCard">
  			<div className="fineryCardContent checkLater">
  				<h2>CHECK BACK LATER FOR MORE LOOKS TO RATE!</h2>
          <div className="socialShareButtons">
            <div className="socialFaceBook" onClick={props.facebookShare}></div>
            <div className="socialTwitter" onClick={props.twitterShare}></div>
          </div>
  			</div>
  		</div>
)
export default CheckLater;



// WEBPACK FOOTER //
// ./src/templates/CheckLater.js